import CommonApi from "./CommonApi";
import ITest from "@/interfaces/ITest";

export default class AdminApi extends CommonApi {
    private usersUrl = "/api/admin/users";
    private assignTestsUrl = "/api/admin/user/assigntests";
    private testsUrl = "/api/admin/testsets";
    private testUrl = "/api/admin/testsets/";
    private questionGroupsUrl = "/api/admin/questiongroups";
    private editTestUrl = "/api/admin/testset/";
    private statisticsTestUrl = "/api/admin/statisticCommon/";
    private staticticsGroupUrl = "/api/admin/statisticGroup/";
    private statisticDateUrl = "/api/admin/statisticDate/";
    private departmentsUrl = "/api/admin/departments";
    private statisticDepartmentUrl = "/api/admin/ExcelDepartment/";
    private statisticUserUrl = "/api/admin/ExcelUser/";
    private statisticTestDetailsUrl = "/api/admin/ExcelTestSet/";

    loadUsers(): Promise<any> {
        return this.getWithToken(this.usersUrl);
    }

    loadTests(): Promise<any> {
        return this.getWithToken(this.testsUrl);
    }

    loadTest(id: number): Promise<any> {
        return this.getWithToken(`${this.testUrl}${id}`);
    }

    loadQuestionGroups(): Promise<any> {
        return this.getWithToken(this.questionGroupsUrl);
    }

    assignTest(testIds: number[], userIds: number[]): Promise<any> {
        return this.postWithToken(this.assignTestsUrl, { TestSetIds: testIds, UserId: userIds }, "Тесты успешно назначены");
    }

    editTest(test: ITest): Promise<any> {
        return this.putWithToken(this.editTestUrl, test, "Тест успешно отредактирован");
    }

    createTest(test: ITest): Promise<any> {
        return this.postWithToken(this.editTestUrl, test, "Тест успешно создан");
    }

    loadStatisticsByTestId(testId: number): Promise<any> {
        return this.getWithToken(`${this.statisticsTestUrl}${testId}`);
    }

    loadStatisticsByGroupId(groupId: number): Promise<any> {
        return this.getWithToken(`${this.staticticsGroupUrl}${groupId}`);
    }

    loadStatisticsByDate(startDate: string, endDate: string): Promise<any> {
        return this.postWithToken(this.statisticDateUrl, { StartDate: startDate, EndDate: endDate }, "Статистика успешно загружена");
    }

    loadDepartments(): Promise<any> {
        return this.getWithToken(this.departmentsUrl);
    }

    loadStatisticByDepartment(department: string): Promise<any> {
        return this.getWithBlob(`${this.statisticDepartmentUrl}${department}`);
    }

    loadStatisticByUser(userId: number): Promise<any> {
        return this.getWithBlob(`${this.statisticUserUrl}${userId}`);
    }

    loadStatisticByTestDetails(testId: number): Promise<any> {
        return this.getWithBlob(`${this.statisticTestDetailsUrl}${testId}`);
    }
}